// extracted by mini-css-extract-plugin
module.exports = {"filter-price-range-wrapper":"MidTermPriceRange_filter-price-range-wrapper__3gGTq","filter-item-container":"MidTermPriceRange_filter-item-container__mfU_C"};